

export const LustTower = {
    level: 2,
    name: 'Lust Tower',
    cpu1Name: 'Gate',
    cpu2Name: 'Mid Tower',
    cpu3Name: 'Dark Altar',
    text: "The Tower of Lust once crowned the land with its radiant crystal, a beacon of the goddess’s grace that bathed the surrounding realms in warmth and desire. Now, the light has been extinguished. Cultists of a dark death god have defiled the tower, smothering the crystal’s glow in shadow. This sacrilege cannot stand. Restore the sacred flame and let the crystal shine once more.",
    classCss: 'map-lust-tower-ico',
    cpu1: {
        id: 49,
        before: {
            type: 'text',
            step: {
                0:  'So… that’s the Lust Tower. \n' +
                    'And those charming figures at the gate? Cultists. Lots of them. \n' +
                    '\n' +
                    'We don’t need anything fancy here — break through, clear the courtyard, and get inside. \n' +
                    '\n' +
                    'Stay close. I flow where the fight is thickest. \n' +
                    'You just make sure nothing slips past you. \n' +
                    '\n' +
                    'Once the gate falls… the real fun begins. ',
            }
        },
        after: {
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/lust_tower/first_win/',
                    slideNumber: 4,
                    backgroundPath: './img/stories/lust_tower/first_win/bg.webp',
                    backgroundSize: {x: 1280, y: 698}
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: "Hey… don’t melt just yet. \n" +
                        "We learned how they fight — next time, we break them. \n" +
                        "\n" +
                        "The tower isn’t going anywhere. \n" +
                        "And neither are we. \n" +
                        "\n" +
                        "Catch your breath… and let’s try again. "
                }
            }
        }
    },
    cpu2: {
        id: 50,
        before: {
            type: 'text',
            step: {
                0: "We’re inside. The air’s thick… the crystal’s corruption is spreading from above. \n" +
                    "\n" +
                    "No shortcuts now — we climb. Floor by floor, through whatever they throw at us. \n" +
                    "\n" +
                    "Stay sharp. The closer we get to the top… the worse it becomes. ",
            }
        },

        after: {
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/lust_tower/second_win/',
                    slideNumber: 3,
                    backgroundPath: './img/stories/lust_tower/second_win/bg.webp',
                    backgroundSize: {x: 1280, y: 698}
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: "Tch… they hit harder up here. \n" +
                        "\n" +
                        "Good. Now we know what waits above. \n" +
                        "\n" +
                        "We climb again… and next time, we don’t stop. ",
                }
            }
        },
    },
    cpu3: {
        id:51,
        before: {
            type: 'text',
            step: {
                0: "There it is… the crystal. And that thing beneath it — the Dark Altar. \n" +
                    "\n" +
                    "It’s feeding them. Every second it stands, they grow stronger. \n" +
                    "\n" +
                    "Don’t get distracted. We strike the altar first… break it, and the rest will fall. \n" +
                    "\n" +
                    "Stay with me. This ends here. ",
            }
        },
        after: {
            player: {
                type: 'comics',
                comicsSetting: {
                    path: './img/stories/lust_tower/after_3_win/',
                    slideNumber: 4,
                    backgroundPath: './img/stories/lust_tower/after_3_win/bg.webp',
                    backgroundSize: {x: 1280, y: 698}
                }
            },
            cpu: {
                type: 'text',
            step: {
                0: "No… we let it stand too long. \n" +
                    "\n" +
                    "That altar is the source — as long as it lives, they’ll keep rising. \n" +
                    "\n" +
                    "Next time, we don’t hesitate. \n" +
                    "We destroy the Dark Altar first… or we lose again. ",
            }
            }
        }
    },
    cpu4: {
        id: 53,
        before: {
            type: 'text',
            step: {
                0: 'Now this is a real fight. The cultists won’t hold back anymore. \n' +
                    '\n' +
                    'But neither will we… I’ll call in a few of my friends to even the odds. ',
            }
        },

        after: {
            player: {
                type: 'text',
                step: {
                    0: "Heh… now that was a fight. \n" +
                        "\n" +
                        "Not everyone makes it through this one… but you did. ",
                }
            },
            cpu: {
                type: 'text',
                step: {
                    0: 'Relax… this one was just for fun. \n' +
                        '\n' +
                        'No losses, no consequences. \n' +
                        '\n' +
                        'Still… I don’t like losing. Let’s try that again. ',
                }
            }
        }
    },
}